import { FormControl } from '@angular/forms';
import { Icons } from '../../services/shared/shared-enums';
import { InvoiceStatusHeader, InvoiceStatusLabel, MyQuotesGridListLabel, MyQuotesGridListObj, MyQuotesState } from './definitions';
import { Count, KngButtonState, KngCardListState, KngFilterState, KngStatusSelectorState } from 'kinetic-angular';
import { SharedFactoryDataService } from '../../services/shared/shared-factory-data.service';
import { LocationAddress, PromoBannerData } from '../../services/shared/shared-interface';
const subscriptionDesktop : PromoBannerData[] = [];
const subscriptionMobile : PromoBannerData[] = [];
export class MyQuotesFactory 
{
	public static build(): MyQuotesState 
	{
		return {
			sectionTop: {
				heading: ''
			},
			sectionMiddle: {
				heading: '',
				search: {
					placeholder: '',
					icon: { iconPath: '', altText: '' },
					invalidSearchText: ''
				},
				filter: {
					filterIcon: { iconPath: '', altText: '' },
					filterText: '',
					clearAll: '',
					selectedFilters: ''
				},
				filteringPanelSection: {
					filterIcon: Icons.filter,
					filterIconAltText: '',
					filterLabel: '',
					selectedFilterLabel: '',
					filterState: this.buildSectionMiddleFilter(),
					searchController: {
						placeholder: '',
						icon: '',
						formControl: new FormControl()
					}
				},
				download: {
					size: 'medium',
					style: 'tertiary',
					disabled: false,
					label: '',
					icon: {
						altText: '',
						iconPath: ''
					},
					position: 'none'
				} as KngButtonState,
				downloadPdfPayload: {
					documentURL: ''
				},
				invoiceStatusUpdated: true,

				gridData: {
					quoteId: '',
					creationDate: '',
					model: '',
					quantity: '',
					billingAddress: '',
					status: '',
					dealerContact: '',
					dealership: '',
					orderID: '',
					accordionIconExpanded: {
						iconPath: '',
						altText: 'invoice $token details'
					},
					accordionIconCollapsed: {
						iconPath: '',
						altText: 'invoice $token details'
					}
				},
				noResult: {
					noResultFoundText: '',
					noResultFoundSubText: '',
					noResultFoundTableIcon: {
						iconPath: '',
						altText: ''
					}
				}
			},
			sectionBottom: {
				sectionPromoBanner: {
					displaySubscription: true,
					subscriptionBanner:
					{
						 subscriptionsDesktop: subscriptionDesktop, subscriptionsMobile: subscriptionMobile 
					}
			  }
			}		
		};
	}
	private static buildSectionMiddleFilter(): KngFilterState 
	{
		return SharedFactoryDataService.getKngFilterState('input');
	}
	public static buildInvoiceStatusCount(): KngStatusSelectorState
	{
		return {
			header: 'Status',
			selectedStatus: 'all',
			count: this.buildCount()
		};
	}
	public static buildCount(): Count[] 
	{
		return [{
			header: InvoiceStatusHeader.all,
			label: InvoiceStatusLabel.all,
			amount: 0
		},
		{
			header: InvoiceStatusHeader.readyForReview,
			label: InvoiceStatusLabel.readyForReview,
			amount: 0
		},
		{
			header: InvoiceStatusHeader.quoteinProcess,
			label: InvoiceStatusLabel.quoteinProcess,
			amount: 0
		},
		{
			header: InvoiceStatusHeader.quoteAccepted,
			label: InvoiceStatusLabel.quoteAccepted,
			amount: 0
		},
		{
			header: InvoiceStatusHeader.ordered,
			label: InvoiceStatusLabel.ordered,
			amount: 0
		},
		{
			header: InvoiceStatusHeader.expired,
			label: InvoiceStatusLabel.expired,
			amount: 0
		}];
	}
	public static myQuoteTabelData():MyQuotesGridListObj
	{
		return {
			quoteId: '', 
			creationDate: '',
			model: '', 
			quantity: '', 
			billingAddress: { 
			  addressLine1: '',
			  addressLine2: '',
			  city: '',
			  zipCode: '',
			  state: ''
			},
			status: '', 
			dealerContact: '',
			dealership: { 
			  dealerName: '',
			  addressLine1: '',
			  city: '',
			  zipCode: '',
			  state: ''
			},
			orderID: '' 
		  }; 
	}
	public static buildTableData(): KngCardListState 
	{
		return SharedFactoryDataService.buildTableDataAccordion();
	}
	public static buildMyQuotesTableLabels(): MyQuotesGridListLabel
	{
		return {
			quoteId: '', 
			creationDate: '',
			model: '', 
			quantity: '', 
			billingAddress: '',
			status: '', 
			dealerContact: '',
			dealership: '',
			orderID: '',
			accordionIconExpanded: {
				iconPath: '',
				altText: ''
			},
    		accordionIconCollapsed: {
				iconPath: '',
				altText: ''
			}
		};
	}
	public static buildMyQuotetList() : KngCardListState
	{
		return SharedFactoryDataService.buildTableList('MyQuotes');
		
	}
	public static billingAddressData(): LocationAddress[]
	{
		return [{
			addressLine1: '',
			addressLine2: '',
			city: '',
			state: '',
			country: '',
			postalCode: ''
		}];
	}
}
